export function createDeferred<T = void>() {
	let resolve: ((value: T) => void) | undefined
	let reject: ((error?: unknown) => void) | undefined

	const promise = new Promise<T>((res, rej) => {
		resolve = res
		reject = rej
	})

	return { promise, resolve, reject }
}

export type Deferred<T> = ReturnType<typeof createDeferred<T>>
